import { boot } from 'quasar/wrappers';
import * as Sentry from '@sentry/vue';

export default boot(({ app }) => {
  if (process.env.SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: process.env.SENTRY_DSN,
      environment: process.env.ENV,
      release: process.env.BUILD_VERSION,
      attachProps: true,
      logErrors: true,
    });
  }
});
